import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getAll(params) {
    return backofficeService.Api().get('student', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getStudentCount(params) {
    return backofficeService.Api().get('student/count', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },


  getAllClassStudent(params) {
    return backofficeService.Api().get('classStudent', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getStudentByClassRoomId(params) {
    return backofficeService.Api().get('classRoomStudent', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },


  getAllTeacherStudent(params) {
    return backofficeService.Api().get('studentTeacher', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getAllstudentExpenseTotal(params) {
    return backofficeService.Api().get('student/totalExpense', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`student/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getDepartmentHistory(id) {
    return backofficeService.Api().get(`student/${id}/department-history`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getClassroomHistory(id) {
    return backofficeService.Api().get(`student/${id}/classroom-history`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  
  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('student', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`student/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`student/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  
  removeStudentFromClass(id, params) {
    return backofficeService.Api().delete(`classStudent/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  removeStudentFromClassRoom(id, params) {
    return backofficeService.Api().delete(`classRoomStudent/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  removeStudentFromTeacher(id, params) {
    return backofficeService.Api().delete(`studentTeacher/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  updateStudentTeacher(id, data) {
    console.log('data', data)
    return backofficeService.Api().put(`studentTeacher/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

}
